import { render, staticRenderFns } from "./tabZDGL.vue?vue&type=template&id=1cbe5bef&scoped=true&"
import script from "./tabZDGL.vue?vue&type=script&lang=js&"
export * from "./tabZDGL.vue?vue&type=script&lang=js&"
import style0 from "./tabZDGL.vue?vue&type=style&index=0&id=1cbe5bef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbe5bef",
  null
  
)

export default component.exports